import React, { useState, useEffect } from 'react';

import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

import dateFormat from 'dateformat';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { SideTab } from '../Components/SideTab';
import AgentEventCalendarPanel from '../Panels/AgentEventCalendarPanel';

export default function CalendarButtonSideNav(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div
        className="text-primary"
        onClick={(e) => {
          setShow(true);
        }}
      >
        <OverlayTrigger placement="top" overlay={<Tooltip placement="right">Calendar</Tooltip>}>
          <i
            className={`sideNavIcon far fa-calendar mr-3 ${props.navSize === 'small' ? 'fa-lg' : ''}`}
          ></i>
        </OverlayTrigger>
        <span className={`sideNavBig ${props.navSize === 'small' ? 'd-none' : ''} `}>Calendar</span>
      </div>

      <SideTab
        size="lg"
        position="right"
        title="Calendar"
        onClose={(e) => setShow(false)}
        show={show}
        scroll={false}
        id={'sidetab-calendar'}
      >
        <AgentEventCalendarPanel {...props} />
      </SideTab>
    </>
  );
}
